import { isLoggedInUser } from './authUtils';
import templateData from '../../utility/getTemplateData';

const MOBILE_MODE_THRESHOLD_WIDTH = 1024;

const getReactButtonsContainerMarginTopExtension = () => {
  if (isLoggedInUser() && window.innerWidth < MOBILE_MODE_THRESHOLD_WIDTH) {
    const { pathname } = window.location;
    if (
      pathname.includes('/donate/buttons/manage') ||
      pathname.includes('/donate/campaigns')
    ) {
      return 0;
    } else if (pathname.includes('/donate/buttons')) {
      return 7;
    }
  }

  return 20;
};

export function setContainerMargins() {
  const merchantHeader = document.getElementById(
    'merchant-header-main-wrapper-internal'
  );
  const reactButtonsContainer = document.getElementById(
    'react-buttons-container'
  );
  if (merchantHeader && reactButtonsContainer && !templateData.isFederated) {
    const merchantHeaderHeight = merchantHeader.offsetHeight;
    const reactButtonsContainerMarginTop =
      merchantHeaderHeight + getReactButtonsContainerMarginTopExtension();
    reactButtonsContainer.style.margin = `${reactButtonsContainerMarginTop}px auto 0`;
  }
}

/**
 * Listens to merchantHeaderMarginUpdate events
 * and sets the appropriate margin between
 * the site header and the elements beneath it.
 * The merchantHeaderMarginUpdate is a custom event
 * the marketing team's code dispatches when the header loads
 * and also when the header changes size formats.
 */
export function setContainerMarginsBefore() {
  document.addEventListener('merchantHeaderMarginUpdate', () => {
    setContainerMargins();
  });
}
